export default class AccessTokenError extends Error {
};
